import React, { useEffect, useState } from "react";
import MainNavbar from "./MainNavbar";
import Hero from "./Hero";
import { Footer } from "./Footer";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Loader from "../customcms/src/components/admin/Loader";
import axios from "axios";
// import { privacyPolicyContent } from "../constants/constants";
import BlogMainContent from "../customcms/src/components/admin/BlogMainContent";


export const PrivacyPolicy = () => {
    const { pathname } = useLocation();
    const apiBaseUrl = process.env.REACT_APP_API_PATH;
    const navigate = useNavigate();
    const [pages, setPages] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await axios.get(`${apiBaseUrl}/pages/${pathname}`);
                setPages(response.data);
                if (response.status === 200) {
                    setLoading(false);
                }
            } catch (err) {
                setError("Page not found");
                navigate('/')
                setLoading(false);
            }
        };
        fetchPage();
    }, [pathname, apiBaseUrl]);
    return (
        <>
            <MainNavbar />
            {loading === true ? <><Loader /></> : <>
                {pages.title && <Hero bgImage={""} imageText={{ title: pages?.title }} />}
                <BlogMainContent content={pages?.content} className="flex-grow" />
            </>}

            <Footer />
        </>
    )
}